import React from 'react';
import Footer from '../components/Footer';

const licenses = [
  {
    title: 'Lee Perry-Smith Head Scan',
    description: '3D Head Scan by Lee Perry-Smith, licensed under Creative Commons Attribution 3.0',
    sourceUrl: 'https://www.triplegangers.com',
    sourceLabel: 'Triple Gangers',
    licenseUrl: 'https://creativecommons.org/licenses/by/3.0/',
    licenseLabel: 'CC BY 3.0',
  },
  {
    title: 'Baseball Cap Pack',
    description: '3D Model by MadeByYeshe, licensed under Creative Commons Attribution',
    sourceUrl: 'https://sketchfab.com/3d-models/baseball-cap-pack-1fceba490cc14bbdb7231acb0272f07c',
    sourceLabel: 'Sketchfab',
    licenseUrl: 'https://creativecommons.org/licenses/by/4.0/',
    licenseLabel: 'CC BY 4.0',
  },
  {
    title: 'Lummi.ai Images',
    description: 'Stock photography',
    sourceUrl: 'https://www.lummi.ai',
    sourceLabel: 'Source',
    licenseUrl: 'https://www.lummi.ai/terms',
    licenseLabel: 'License',
  },
  {
    title: 'Hanssen Template',
    description: 'Website template design by Pawel Gola',
    sourceUrl: 'https://templates.gola.io/',
    sourceLabel: 'Pawel Gola',
    licenseUrl: 'https://webflow.com/templates/html/hanssen-portfolio-website-template',
    licenseLabel: 'Webflow',
  },
  {
    title: 'Meta Spatial Editor Screenshot',
    description: 'SpatialEditor.webp image from Meta Spatial SDK documentation',
    sourceUrl: 'https://developers.meta.com/horizon/documentation/spatial-sdk/spatial-editor-overview/',
    sourceLabel: 'Meta Developers',
    licenseUrl: 'https://developers.meta.com/horizon/documentation/spatial-sdk/spatial-editor-overview/',
    licenseLabel: 'Source',
  },
  {
    title: 'Meta Connect Keynote Screenshot',
    description: 'Meta Connect Keynote screenshot from Meta Connect Keynote',
    sourceUrl: 'https://www.reddit.com/r/VR180Film/comments/1nknljk/did_you_notice_the_meta_connect_2025_was_shot/',
    sourceLabel: 'Meta Connect Keynote',
    licenseUrl: 'https://www.reddit.com/r/VR180Film/comments/1nknljk/did_you_notice_the_meta_connect_2025_was_shot/',
    licenseLabel: 'Source',
  }
];

const Licensing = () => {
  return (
    <main className="main-wrapper">
      <div className="main-wrapper-left">
        <div className="about-hero-image-wrapper">
          <img loading="lazy" src="/images/headshots/JP1.2@2x.webp" alt="Licensing" className="about-hero-image" />
        </div>
      </div>
      <div className="main-wrapper-right">
        <div className="about-right">
          <section className="section-about-awards">
            <div className="about-exhibition-top">
              <h2 className="heading-style-h2">Licensing</h2>
              <div className="max-width-medium">
                <div>Credits and license information for third-party assets used on this site.</div>
              </div>
            </div>
            {licenses.map((item) => (
              <div key={item.title} className="awards-item" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'baseline' }}>
                  <h3 className="heading-style-h5" style={{ margin: 0 }}>{item.title}</h3>
                  <div style={{ display: 'flex', gap: '1.5rem' }}>
                    <a href={item.sourceUrl} target="_blank" rel="noreferrer" className="text-meta text-style-link">
                      {item.sourceLabel}
                    </a>
                    <a href={item.licenseUrl} target="_blank" rel="noreferrer" className="text-meta text-style-link">
                      {item.licenseLabel}
                    </a>
                  </div>
                </div>
                <div className="text-meta text-color-muted" style={{ marginTop: '0.25rem' }}>{item.description}</div>
              </div>
            ))}
          </section>

          <Footer />
        </div>
      </div>
    </main>
  );
};

export default Licensing;
